import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../main/context/Provider';
import { Customer } from '../../../domain/customers/customer';
import { useParams } from 'react-router-dom';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { ProjectStatus } from '../../../domain/projectStatus/projectStatus';
import { ProjectStatusRepository } from '../../../infrastructure/repositories/projectStatus/projectStatusRepository';
import { Private_Routes } from '../../../main/constants';
import { ProjectStatusForm } from '../components/form/ProjectStatusForm';

export const UpdateProjectStatusPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const [projectStatus, setProjectStatus] = useState<ProjectStatus>();
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Actualizar Estado');

    useEffect(() => {
        if (id) {
            ProjectStatusRepository.GetProjectState(id).then((response) =>
                setProjectStatus(response)
            );
        }
    }, [id]);

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Estados',
                route: Private_Routes.PROJECT_STATUS_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.UPDATE_PROJECT_STATUS,
            },
        ]);
    }, [lang]);

    return (
        <>
            {projectStatus != null && (
                <ProjectStatusForm
                    isNewProjectStatus={false}
                    projectStatus={projectStatus}
                />
            )}
        </>
    );
};
